
<template>
  <!--版本管理-->
  <div>
    <x-tabula
      :dataSource="dataSource"
      rowKey="app_version_id"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="true"
    >
    </x-tabula>

    <!--二维码的弹窗-->
    <a-modal
      title="二维码"
      :visible="visible"
      @ok="confirm"
      @cancel="visible=false"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <div style="text-align: center">
        <img style="width: 200px;" :src="imgUrl" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.fetchSelect],
  name: 'appVersion',
  data () {
    return {
      imgUrl: '',
      visible: false,
      searchList: [
        { props: ['version'], placeholder: '版本号', inputType: 'input' },
        { props: ['app_id'], placeholder: '选择应用', options: [], inputType: 'select' },
        { props: ['os_type'], placeholder: '选择平台', options: this.$store.state.platformList, inputType: 'select' }
      ],
      tableOptList: [
        { text: '新增', icon: 'plus', key: 'addbtn' },
        { text: '删除', icon: 'close', disabled: true, key: 'batchDel' }
      ],
      rowOptList: [
        { text: '下载二维码', handle: (row) => this.downloadQRcode(row.app_version_id), key: 'download' },
        {text: '修改', handle: row => this.$children[0].toEdit(row), key: 'edit'},
        { text: '删除', handle: row => this.$children[0].showDeleteConfirm(row), key: 'delete' }
      ],
      columns: [
        { title: '版本号', dataIndex: 'version', align: 'left', width: '' },
        { title: '应用', dataIndex: 'app_name', align: 'left', width: '' },
        // { title: 'Code', dataIndex: 'code', align: 'left', width: '' },
        { title: '平台', dataIndex: 'os_desc', align: 'left', width: '' },
        { title: '是否强制升级', dataIndex: 'is_force_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      searchParams: {
        version: undefined,
        app_id: undefined,
        os_type: undefined
      },
      listApi: {
        url: '/app_version',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'addVersion',
        title: '修改版本'
      },
      deleteParam: {
        url: '/app_version',
        param: {pk_key: 'app_version_id', pk_val: ''},
        title: '版本',
        key: 'version'
      }
    };
  },
  mounted () {
    this.marketingManageSelect([{index: 1, key: 'apps_list'}]);
  },
  methods: {
    /* 下载二维码 */
    downloadQRcode (id) {
      this.$get({
        url: 'qrcode_img',
        params: { app_version_id: id },
        config: {responseType: 'blob'}
      }).then((res) => {
      }).catch((res) => {
        let isImg = res.headers['content-type'].indexOf('image') >= 0;
        if (isImg) {
          let data = res.data;
          this.imgUrl = window.URL.createObjectURL(new Blob([data], { type: data.type }));
          this.visible = true;
        } else {
          this.$message.error('二维码地址不存在');
        }
      });
    },
    confirm () {
      this.visible = false;
      this.imgUrl = '';
    },
    resHandle (res) {
      console.log('处理list返回数据: ');
      return res;
    },
    searchHandle (selectData) {
      console.log('处理搜索数据: ', selectData);
      // return selectData;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/systemSet/appVersion/appVersion.vue